export default "__VITE_ASSET__fb019142__"